import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import ThreeBackground from '../aether/components/ThreeBackground';
import Logo from '../../components/Logo';

export default function ArchitecturePage() {
  const navigate = useNavigate();
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  const mockGallery = [
    {
      id: 1,
      title: "Villa Mistral | Concrete & Glass",
      category: "Residential Architecture",
      author: "ArchDaily Renderfarm",
      image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 2,
      title: "Nordic Minimalist Pavilion",
      category: "Exhibition Space",
      author: "Studio OMA",
      image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 3,
      title: "Desert Oasis Retreat",
      category: "Hospitality Design",
      author: "Renderfarm Collective",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 4,
      title: "The Parametric Canopy",
      category: "Urban Intervention",
      author: "Zaha Hadid Architects",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&fit=crop",
      height: "h-72"
    },
    {
      id: 5,
      title: "Brutalist Cliffside Residence",
      category: "Residential",
      author: "ArchDaily Featured",
      image: "https://images.unsplash.com/photo-1600607687920-4e2a09be1587?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 6,
      title: "Luminescent Art Gallery",
      category: "Cultural Space",
      author: "VizTeam Studio",
      image: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 7,
      title: "Floating Bamboo Structure",
      category: "Sustainable Design",
      author: "EcoRender",
      image: "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=800&fit=crop",
      height: "h-100"
    },
    {
      id: 8,
      title: "Metropolitan Glass Skyscraper",
      category: "Commercial",
      author: "ArchDaily Renderfarm",
      image: "https://images.unsplash.com/photo-1506974210756-8e1b8985d348?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 9,
      title: "Hidden Forest Cabin",
      category: "Micro Architecture",
      author: "Nordic Arch",
      image: "https://images.unsplash.com/photo-1449198063792-7d754d6f3c80?w=800&fit=crop",
      height: "h-72"
    },
    {
      id: 10,
      title: "Futuristic Museum Concept",
      category: "Public Architecture",
      author: "Render Masters",
      image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 11,
      title: "Monolithic House",
      category: "Residential",
      author: "Studio Brutal",
      image: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 12,
      title: "Alpine Ski Resort Extension",
      category: "Hospitality",
      author: "ArchDaily Renderfarm",
      image: "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 13,
      title: "Absolute Towers Concept",
      category: "Organic Architecture",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1541888043685-6101188d4d7a?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 14,
      title: "Heydar Aliyev Center Flow",
      category: "Parametric Design",
      author: "Zaha Hadid Architects",
      image: "https://images.unsplash.com/photo-1588693959306-69675ebc4021?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 15,
      title: "The Shard Structural Detail",
      category: "High-Tech Architecture",
      author: "Renzo Piano Building Workshop",
      image: "https://images.unsplash.com/photo-1528646199343-7f28740d7c08?w=800&fit=crop",
      height: "h-100"
    },
    {
      id: 16,
      title: "Pinterest Aesthetic Loft",
      category: "Interior Architecture",
      author: "Studio Minimal",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 17,
      title: "Harbin Opera House Study",
      category: "Cultural Landmark",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1496309732348-3627f3f040ee?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 18,
      title: "Centre Pompidou Exterior Mechanics",
      category: "Structural Expressionism",
      author: "Renzo Piano & Richard Rogers",
      image: "https://images.unsplash.com/photo-1565551694356-8a0a9fc3251c?w=800&fit=crop",
      height: "h-72"
    },
    {
      id: 19,
      title: "Fluid Concrete Atrium",
      category: "Parametric Design",
      author: "Zaha Hadid Tribute",
      image: "https://images.unsplash.com/photo-1545620959-866cd8512117?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 20,
      title: "Boho Chic Desert Villa",
      category: "Residential Rendering",
      author: "ArchDaily x Pinterest",
      image: "https://images.unsplash.com/photo-1510627489930-0c1b0bfb6785?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 21,
      title: "CopenHill Ski Slope Power Plant",
      category: "Sustainable Infrastructure",
      author: "BIG - Bjarke Ingels Group",
      image: "https://images.unsplash.com/photo-1596706928091-8848db9a8264?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 22,
      title: "The Twist Museum",
      category: "Cultural Architecture",
      author: "BIG - Bjarke Ingels Group",
      image: "https://images.unsplash.com/photo-1524815436852-eb00171a5cde?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 23,
      title: "Quzhou Sports Campus",
      category: "Landscape Architecture",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1490214812328-98e3bfae6fde?w=800&fit=crop",
      height: "h-100"
    },
    {
      id: 24,
      title: "VIA 57 West",
      category: "Residential Courtscraper",
      author: "BIG - Bjarke Ingels Group",
      image: "https://images.unsplash.com/photo-1506146332389-18140dc7b2fb?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 25,
      title: "Ordos Museum in the Desert",
      category: "Parametric Blob",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1478147424096-f1396b24d777?w=800&fit=crop",
      height: "h-72"
    },
    {
      id: 26,
      title: "LEGO House",
      category: "Experience Center",
      author: "BIG - Bjarke Ingels Group",
      image: "https://images.unsplash.com/photo-1563200921-1ea40ebc7ef6?w=800&fit=crop",
      height: "h-96"
    },
    {
      id: 27,
      title: "Chaoyang Park Plaza",
      category: "Shanshui City Concept",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1517586979036-b7d1e86b2345?w=800&fit=crop",
      height: "h-80"
    },
    {
      id: 28,
      title: "8 House Stepped Roof",
      category: "Mixed-Use Development",
      author: "BIG - Bjarke Ingels Group",
      image: "https://images.unsplash.com/photo-1473615690315-0952d7e0031c?w=800&fit=crop",
      height: "h-64"
    },
    {
      id: 29,
      title: "One River North",
      category: "Biophilic Design",
      author: "MAD Architects",
      image: "https://images.unsplash.com/photo-1451976426598-a7593bd6d0b2?w=800&fit=crop",
      height: "h-100"
    },
    {
      id: 30,
      title: "Google North Bayshore Canopy",
      category: "Corporate Campus",
      author: "BIG & Heatherwick Studio",
      image: "https://images.unsplash.com/photo-1501430654243-c934cec2e1c0?w=800&fit=crop",
      height: "h-72"
    }
  ];

  useEffect(() => {
    const fetchLiveNews = async () => {
      try {
        const rssUrl = encodeURIComponent("https://news.google.com/rss/search?q=Architecture+Parametric+Design+Aerospace+Engineering&hl=en-US&gl=US&ceid=US:en");
        const res = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${rssUrl}`);
        const data = await res.json();
        
        if (data.status === 'ok' && data.items && data.items.length > 0) {
          const liveGallery = data.items.slice(0, 15).map((item, index) => {
            let imgMatch = item.description?.match(/<img[^>]+src="([^">]+)"/);
            let imgUrl = imgMatch ? imgMatch[1] : null;
            
            const fallbackImages = [
              "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&fit=crop",
              "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&fit=crop",
              "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&fit=crop",
              "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&fit=crop",
              "https://images.unsplash.com/photo-1600607687920-4e2a09be1587?w=800&fit=crop",
              "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?w=800&fit=crop",
              "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=800&fit=crop",
              "https://images.unsplash.com/photo-1506974210756-8e1b8985d348?w=800&fit=crop"
            ];
            if (!imgUrl) imgUrl = fallbackImages[index % fallbackImages.length];

            const heights = ["h-96", "h-64", "h-80", "h-72", "h-100"];

            return {
              id: item.guid || index,
              title: item.title,
              category: "Live Intel",
              author: item.source || "Global Feed",
              image: imgUrl,
              height: heights[index % heights.length],
              link: item.link
            };
          });
          setGallery([...mockGallery, ...liveGallery]);
        } else {
          setGallery(mockGallery);
        }
      } catch (error) {
        console.error("Failed to fetch architecture news:", error);
        setGallery(mockGallery);
      } finally {
        setLoading(false);
      }
    };

    fetchLiveNews();
  }, []);

  return (
    <div className="min-h-screen text-aether-light font-sans relative overflow-x-hidden bg-background">
      <ThreeBackground />

      {/* Top Navbar */}
      <header className="fixed top-0 w-full z-50 bg-background/40 backdrop-blur-[40px] border-b border-primary/10 h-20">
        <div className="flex justify-between items-center w-full px-8 max-w-7xl mx-auto h-full">
          <div className="cursor-pointer" onClick={() => navigate('/')}>
            <Logo />
          </div>
          <nav className="hidden md:flex items-center space-x-12">
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/curation')}>Curation</span>
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/')}>Feed</span>
            <span className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors duration-300 cursor-pointer" onClick={() => navigate('/salon')}>Salon</span>
            <span className="font-label-caps text-label-caps text-primary border-b border-primary pb-1 cursor-pointer">Architecture</span>
          </nav>
          <div className="flex items-center gap-4">
            <span className="material-symbols-outlined cursor-pointer hover:opacity-80 transition-opacity">notifications</span>
            <span className="material-symbols-outlined cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('/curation')}>account_circle</span>
          </div>
        </div>
      </header>

      {/* Main Layout */}
      <div className="max-w-7xl mx-auto pt-32 px-4 pb-12 flex gap-8 relative z-10">
        
        {/* Left Sidebar */}
        <div className="hidden lg:block w-64 flex-shrink-0 space-y-8">
          <div className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)]">
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/')}>
                <span className="material-symbols-outlined text-lg">home</span> Feed
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/curation')}>
                <span className="material-symbols-outlined text-lg">explore</span> Curation
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate('/salon')}>
                <span className="material-symbols-outlined text-lg">groups</span> Salon
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-primary transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-on-surface-variant" onClick={() => navigate('/gaming')}>
                <span className="material-symbols-outlined text-lg">sports_esports</span> Game News
              </li>
              <li className="flex items-center gap-3 cursor-pointer text-primary">
                <span className="material-symbols-outlined text-lg">domain</span> Architecture
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-[#d4af37] transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-on-surface-variant" onClick={() => navigate('/contracts')}>
                <span className="material-symbols-outlined text-lg">work</span> Contracts
              </li>
            </ul>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 space-y-8">
          <div className="mb-10 text-center md:text-left">
            <h2 className="font-playfair text-5xl text-primary mb-3">Architecture & Tech</h2>
            <p className="text-sm text-on-surface-variant/60 font-light tracking-widest uppercase">Blueprints, Infrastructure, and Space Habitats</p>
          </div>

          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
            {loading ? (
              <div className="text-center py-20 col-span-full w-full">
                <span className="material-symbols-outlined animate-spin text-4xl text-primary mb-4 block mx-auto">sync</span>
                <p className="text-sm text-primary tracking-widest uppercase animate-pulse">Fetching Blueprints...</p>
              </div>
            ) : (
              gallery.map((item, idx) => (
                <motion.article 
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1, duration: 0.5 }}
                  key={item.id} 
                  onClick={() => item.link && window.open(item.link, '_blank')}
                  className="break-inside-avoid glass-panel rounded-2xl border border-[rgba(255,255,255,0.05)] overflow-hidden group cursor-pointer hover:border-primary/40 transition-colors relative"
                >
                  <div className={`w-full overflow-hidden relative ${item.height}`}>
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    
                    {/* Overlay Gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity"></div>
                    
                    {/* Category Badge */}
                    <div className="absolute top-4 left-4 px-3 py-1 bg-black/60 backdrop-blur-md rounded-full border border-white/10">
                      <span className="text-[9px] uppercase tracking-widest text-white/90 font-bold">{item.category}</span>
                    </div>

                    {/* Text Content overlaying image at bottom */}
                    <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform">
                      <h3 className="font-playfair text-xl text-white mb-1 group-hover:text-primary transition-colors">{item.title}</h3>
                      <p className="text-[10px] uppercase tracking-widest text-white/50">By {item.author}</p>
                    </div>
                  </div>
                </motion.article>
              ))
            )}
          </div>
        </div>

      </div>
    </div>
  );
}
